module.exports = __webpack_public_path__ + "img/logo.9e54ce98.png";